export default __webpack_public_path__ + "static/invoiceCardLeft-4cebf64ed1c2bdb3519561c95cf8ee6b.png";